import simpleNavigation from './simpleMobileNavigation';

export default function initMobileNav() {
    simpleNavigation();
    jQuery('body').mobileNav({
        menuActiveClass: 'nav-active',
        menuOpener: '.js-nav-opener',
        clearClass: 'search-active'
    });
}
